export const formatClassname = (classNames) =>
  classNames.filter((c) => c).join(' ');
